export const isValidDate = (d) => d instanceof Date && !isNaN(d as any);

export const formatDate = (d: Date): string => isValidDate(d) ? d.toLocaleDateString() : "-";

export const formatTime = (d: Date): string => d.toLocaleTimeString();

export const formatDateTime = (d: Date): string => isValidDate(d) ? formatDate(d) + ' ' + formatTime(d) : "-";



// WEBPACK FOOTER //
// ./src/core/i18n/date.tsx